module.exports = "<p>\r\n  deletedecouvert works!\r\n</p>\r\n"